import { createSlice, PayloadAction } from '@reduxjs/toolkit'

type PlainInfo<T> = {
  status: RequestState
  error?: string | null
  data: T
}

type RequestState = 'pending' | 'fulfilled' | 'rejected' | 'none'

interface CheckoutState {
  meta: PlainInfo<Oms.InvoiceMetaData>
  paymentMethods: PlainInfo<Oms.PaymentMethod[]>
}

const initialState: CheckoutState = {
  meta: {
    status: 'none',
    error: null,
    data: {} as Oms.InvoiceMetaData,
  },
  paymentMethods: {
    status: 'none',
    data: [],
  },
}

export const invoiceSlice = createSlice({
  name: '@invoice',
  initialState,
  reducers: {
    setDefaultInvoiceOrder: (
      state,
      action: PayloadAction<Oms.V4ApiResponse<Oms.InvoiceMetaData>>
    ) => {
      state.meta.data = action.payload.data
      state.meta.error = action?.payload?.errors?.[0]?.errorCode
      state.meta.status = !action?.payload?.errors?.[0]?.errorCode
        ? 'fulfilled'
        : 'rejected'
    },
  },
  extraReducers: (builder) => {},
})

export const { setDefaultInvoiceOrder } = invoiceSlice.actions
